"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVideoPQLMap = exports.getVidyardTosMap = exports.getIsVideoPQLBannerDismissed = exports.getVidyardTosStatus = void 0;

var _immutable = _interopRequireDefault(require("immutable"));

var _Constants = require("FileManagerCore/Constants");

var _FileManagerPortalDataCategories = _interopRequireDefault(require("../enums/FileManagerPortalDataCategories"));

var createCategoryValueGetter = function createCategoryValueGetter(defaultValue) {
  return function (categoryMap) {
    return categoryMap.get('category_value') || defaultValue;
  };
};

var getVidyardTosStatus = createCategoryValueGetter(_Constants.VidyardTosStatus.NOT_ASKED);
exports.getVidyardTosStatus = getVidyardTosStatus;
var getIsVideoPQLBannerDismissedValue = createCategoryValueGetter(false);

var getIsVideoPQLBannerDismissed = function getIsVideoPQLBannerDismissed(videoPqlMap) {
  return getIsVideoPQLBannerDismissedValue(videoPqlMap) === 'true';
};

exports.getIsVideoPQLBannerDismissed = getIsVideoPQLBannerDismissed;

var createCategoryMapGetter = function createCategoryMapGetter(portalDataCategory) {
  return function (portalDataList) {
    return portalDataList.find(function (portalDataMap) {
      return portalDataMap.get('category') === portalDataCategory;
    }) || _immutable.default.Map();
  };
};

var getVidyardTosMap = createCategoryMapGetter(_FileManagerPortalDataCategories.default.VIDYARD_TOS_STATUS);
exports.getVidyardTosMap = getVidyardTosMap;
var getVideoPQLMap = createCategoryMapGetter(_FileManagerPortalDataCategories.default.DISMISS_VIDEO_PQL_V1);
exports.getVideoPQLMap = getVideoPQLMap;